import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../constants/svgIcon';
import useLocale from '../../../hooks/useLocale';
import { AlbumPartition } from '../../../models/SpaceStore';
import { WebBoosterType } from '../../../models/UserStore';
import { SvgIcon } from '../SVGIcon';

import styles from './FolderBreadcrumbRow.module.css';

export enum FolderBreadcrumbText {
  All = 'All',
  Default = 'default',
  NewFolder = 'New Folder',
}

export enum FolderBreadcrumbVariant {
  White = 'variant-white',
  Black = 'variant-black',
}

export type FolderBreadcrumbRowProps = {
  webBoosterType: WebBoosterType | undefined;
  breadcrumbs: AlbumPartition[];
  variant: FolderBreadcrumbVariant;
  onClickBreadcrumb?: () => void;
};

export const FolderBreadcrumbRow = memo(
  ({
    webBoosterType,
    breadcrumbs,
    variant,
    onClickBreadcrumb,
  }: FolderBreadcrumbRowProps) => {
    const { t } = useTranslation();
    const l = useLocale();
    return (
      <div className={`${styles.breadcrumbRow} ${styles[variant]}`}>
        <SvgIcon
          name={SVGIconType.Classroom}
          width={24}
          height={24}
          style={{ flexShrink: '0' }}
        />
        <p className={styles.normalTextArrow}>{'>'}</p>
        {breadcrumbs.map((breadcrumb, index) => (
          <div
            key={index}
            className={styles.breadcrumb}
            onClick={onClickBreadcrumb}
          >
            {breadcrumb.partitionId ===
            `${webBoosterType}-${FolderBreadcrumbText.All}` ? (
              <p className={styles.boldText}>{t('All Content')}</p>
            ) : (
              <p className={styles.normalText}>
                {breadcrumb.partitionId ===
                `${webBoosterType}-${FolderBreadcrumbText.Default}`
                  ? t('Default Folder')
                  : l(breadcrumb.i18nGameSetPartitionInfo).name}
              </p>
            )}
            <SvgIcon
              name={SVGIconType.Arrow}
              width={16}
              height={16}
              className={styles.arrowIcon}
              style={{ marginTop: '2px' }}
            />
          </div>
        ))}
      </div>
    );
  },
);
